import { render, staticRenderFns } from "./ListaDescredenciados.vue?vue&type=template&id=8656973e&scoped=true"
import script from "./ListaDescredenciados.vue?vue&type=script&lang=js"
export * from "./ListaDescredenciados.vue?vue&type=script&lang=js"
import style0 from "./ListaDescredenciados.vue?vue&type=style&index=0&id=8656973e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8656973e",
  null
  
)

export default component.exports